import type { ReactNode } from 'react';

import type { DataQaInterface } from '@utilities/helpers/types';

import { PriceDetailItem } from './PriceDetailItem';

export type PriceDetailItemType = DataQaInterface & {
  description: ReactNode;
  value: ReactNode;
  isStrong?: boolean;
  tooltip?: string;
  isLoading?: boolean;
};

type Props = {
  items: PriceDetailItemType[];
  isLoading?: boolean;
};

export const PriceDetails = ({ items, isLoading }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item, index) => {
        return (
          <PriceDetailItem
            description={item.description}
            value={isLoading ? <span className="skeleton-text h-3 w-16" /> : item.value}
            tooltip={item.tooltip}
            isStrong={item.isStrong}
            isLoading={item.isLoading}
            dataQa={item.dataQa}
            key={index}
          />
        );
      })}
    </div>
  );
};
